import React, { useEffect } from 'react'
import FAQ from './FAQ'
import { Link } from "react-router-dom";
import { Button } from 'antd';

export default function Fiction(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Works of fiction";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_1713485986_600.jpg'}
                    srcSet={`/images/shutterstock_1713485986_1200.jpg 4000w`}
                    alt="Works of fiction"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1>Proofreading works of fiction</h1>
                    </header>
                    <p>
                        For only &#163;4.99 per 1000 words have your piece of fiction professionally proofread. Be assured grammar, spellings, paragraph-grouping, punctuations and suggestions for alternative appropriate word choice(s) shall be meticulously taken care of. All pieces of fiction will be accepted.
                    </p>
                    <p>0.1% of the revenue earned goes to StripeClimate. Every proofread makes a difference to your manuscript and the planet.</p>
                    <Link to="/request?service=fiction"><Button type="primary">Request to proofread</Button></Link>
                </div>
            </div>

            <div className="content-wrapper">
                <FAQ topic='fiction' />
                <FAQ topic='general' />
            </div>
        </div>
    )
}
